const BillingRates = {
  US: 20,
  IN: 180,
};

export default BillingRates;
export { BillingRates };
